export default "__VITE_ASSET__2fca9365__"